import { render } from "./AssignedTasks.vue?vue&type=template&id=de473b0c&scoped=true"
import script from "./AssignedTasks.vue?vue&type=script&lang=js"
export * from "./AssignedTasks.vue?vue&type=script&lang=js"

import "./AssignedTasks.vue?vue&type=style&index=0&id=de473b0c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de473b0c"]])

export default __exports__